import { useEffect } from 'react';

import { isModalOpen, ModalsManager } from '@/components/modals/modalsManager';
import { IntegrationManagementModal } from '@/features/integration-management';
import { clearHash, getHash } from '@/hooks/useHashRoute';

import { openSettings, parseSettingsHash } from './settings-navigation';
import {
  INTEGRATION_MANAGEMENT_HASH,
  providerKeyFromIntegrationSearchId,
} from './settings-search-dom';

const managementItem = parseSettingsHash(INTEGRATION_MANAGEMENT_HASH)?.item;

export function useSettingsHashRedirect() {
  useEffect(() => {
    const redirect = () => {
      const target = parseSettingsHash(getHash());
      if (!target) return;

      if (target.section === 'Integrations' && target.item) {
        const providerKey = providerKeyFromIntegrationSearchId(target.item);
        if (providerKey || target.item === managementItem) {
          const props = { providerKey: providerKey ?? undefined };
          if (isModalOpen(IntegrationManagementModal)) {
            ModalsManager.update(IntegrationManagementModal, props);
          } else {
            ModalsManager.show(IntegrationManagementModal, props);
          }
          clearHash();
          return;
        }
      }

      void openSettings(target.section, target.item)?.then(clearHash);
    };
    redirect();
    window.addEventListener('hashchange', redirect);
    return () => window.removeEventListener('hashchange', redirect);
  }, []);
}
